import "chart.js/auto";
import "chart.js";
import { useLocale, useService, useElement, useComponent } from "../../../hooks";
import { useSettings } from "./hooks";

export const Settings = () => {
  const { t } = useLocale();
  const { setTitle } = useService("Meta");
  const BackIcon = useElement("BackIcon");
  const Input = useElement("Input");
  const Button = useElement("Button");
  const Box = useComponent("Box");
  const MediaBox = useComponent("MediaBox");
  const { logo, setLogo, updateLogo, logoWhite, setLogoWhite, updateLogoWhite } = useSettings();

  setTitle(t("setting"), "admin");
  return (
    <div id="content-box" className="content">
      <h1 className="title">
        <BackIcon backLink="/admin/dashboard" />
        {t("setting")}
      </h1>
      <div className="columns">
        <div className="left">
          <Box title="Logo Settings">
            <div className="flex align-center">
              <div style={{ width: "100%", marginRight: "20px" }}>
                <Input
                  label="Logo URL"
                  value={logo}
                  onChange={(e) => setLogo(e.target.value)}
                  placeholder="Enter logo URL or select from media"
                />
              </div>
              <div style={{ minWidth: "200px" }}>
                <MediaBox
                  label="Select Logo"
                  setimage={(img) => {
                    try {
                      const parsed = JSON.parse(img);
                      if (Array.isArray(parsed) && parsed.length > 0) {
                        setLogo(parsed[0]);
                      }
                    } catch (e) {
                      setLogo(img);
                    }
                  }}
                  image={JSON.stringify(logo ? [logo] : [])}
                />
              </div>
            </div>
            <Button
              className="btn btn-primary mt20"
              onClick={() => updateLogo(logo)}
            >
              Update Logo
            </Button>
          </Box>

          <Box title="Logo White Settings">
            <div className="flex align-center">
              <div style={{ width: "100%", marginRight: "20px" }}>
                <Input
                  label="Logo White URL"
                  value={logoWhite}
                  onChange={(e) => setLogoWhite(e.target.value)}
                  placeholder="Enter white logo URL or select from media"
                />
              </div>
              <div style={{ minWidth: "200px" }}>
                <MediaBox
                  label="Select Logo White"
                  setimage={(img) => {
                    try {
                      const parsed = JSON.parse(img);
                      if (Array.isArray(parsed) && parsed.length > 0) {
                        setLogoWhite(parsed[0]);
                      }
                    } catch (e) {
                      setLogoWhite(img);
                    }
                  }}
                  image={JSON.stringify(logoWhite ? [logoWhite] : [])}
                />
              </div>
            </div>
            <Button
              className="btn btn-primary mt20"
              onClick={() => updateLogoWhite(logoWhite)}
            >
              Update Logo White
            </Button>
          </Box>
        </div>
        <div className="right">
          <Box title="Metadata">
            <p>Configure your site's branding assets.</p>
          </Box>
        </div>
      </div>
    </div>
  );
};
